export { Model as PersonConsent } from './model'
export { Store as PersonConsentStore } from './store'
